const InstagramLogo = ({ white = false }) => (
  <svg viewBox="0 0 64 64">
    <defs>
      <linearGradient
        id="instaLogo"
        x1="8"
        y1="56"
        x2="56"
        y2="8"
      >
        <stop offset="0%" stopColor="#ff8a3d" />
        <stop offset="45%" stopColor="#f02cff" />
        <stop offset="100%" stopColor="#6c5cff" />
      </linearGradient>
    </defs>

    <rect
      x="14"
      y="14"
      width="36"
      height="36"
      rx="11"
      fill="none"
      stroke={white ? '#fff' : 'url(#instaLogo)'}
      strokeWidth="4"
    />

    <circle
      cx="32"
      cy="32"
      r="9"
      fill="none"
      stroke={white ? '#fff' : 'url(#instaLogo)'}
      strokeWidth="4"
    />

    <circle
      cx="43"
      cy="21"
      r="2.8"
      fill={white ? '#fff' : 'url(#instaLogo)'}
    />
  </svg>
);

export default InstagramLogo;
